import React from "react";

interface SuccessMsgProps {
    successMessage: string;
}

const SuccessMessage: React.FC<SuccessMsgProps> = (
    {
        successMessage,

    }
) => {
    return (
        <p className="o-success-message">
            {successMessage}
        </p>
    )
}

export default SuccessMessage;
